import { combineReducers } from 'redux';
import { createReducer } from '@api/createRequestStore';
import * as types from './types';

const filtersData = createReducer(types.FILTERS_THRESHOLD_SCOPE);
const trendsData = createReducer(types.TRENDS_THRESHOLD_SCOPE);
export default combineReducers({
  filtersData,
  trendsData,
});
